import { render, staticRenderFns } from "./CardProductBag.vue?vue&type=template&id=49663cd6"
import script from "./CardProductBag.vue?vue&type=script&lang=js"
export * from "./CardProductBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports